var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlanco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.88,
    y: 3.01,
    width: 34.68,
    height: 34.47
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    className: "cls-2",
    d: "M37.57,20.35c0-9.58-7.77-17.34-17.34-17.34-9.58,0-17.34,7.77-17.34,17.34,0,8.53,6.21,15.79,14.63,17.12v-12.12h-4.4v-5.01h4.4v-3.82c0-4.35,2.59-6.75,6.55-6.75,1.3.02,2.6.13,3.88.34v4.27h-2.19c-2.15,0-2.83,1.34-2.83,2.71v3.25h4.81l-.77,5.01h-4.04v12.12c8.43-1.34,14.63-8.6,14.63-17.13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlanco);
export default __webpack_public_path__ + "static/media/FacebookBlanco.fa6d6aee718f01b93b9123ceecaeac9b.svg";
export { ForwardRef as ReactComponent };